import { Box, Card, CardContent, Grid } from '@material-ui/core'
import React, { useState } from 'react'
import {
  components
} from 'cng-web-lib'

import LogisticsAdminTranslationText from './LogisticsAdminTranslationText'
import { useHistory } from 'react-router-dom'
import { v4 as uuid } from 'uuid'
import MGTTApiUrls from 'src/apiUrls/MGTTApiUrls'

const {
  card: { CngSimpleCardHeader },
  table: {
    CngCrudTable,
    useDefaultNotification
  }
} = components

function TablePage(props) {
  const {
    location: { pathname },
    showNotification
  } = props

  const [stateKey, setStateKey] = useState(uuid())
  const history = useHistory()
  const notification = useDefaultNotification(showNotification)
  const translatedTextsObject = LogisticsAdminTranslationText()

  const columns = [
    {
      field: "configFor",
      title: translatedTextsObject.configFor,
    },
    {
      field: "configValue1",
      title: translatedTextsObject.configValue1,
    },
    {
      field: "configValue2",
      title: translatedTextsObject.configValue2,
    },
    {
      field: "configValue3",
      title: translatedTextsObject.configValue3,
    },
    {
      field: "configDescription",
      title: translatedTextsObject.configDescription,
    }
  ]

  const onEditButtonClick = (event, record) => {
    history.push(`${pathname}/edit/` + record.id)
  }

  const onViewButtonClick = (event, record) => {
    history.push(`${pathname}/view/` + record.id)
  }

  return (
    <Box>
      <Card>
        <CngSimpleCardHeader title={translatedTextsObject.clogsConfigTableTitle} />
        <CardContent>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <CngCrudTable
                {...props}
                fieldLevel="toBeChangedByDeveloperIfWantFieldLevelRestriction"
                addRoute={`${pathname}/add`} //frontend URL 
                columns={columns}
                del={{ url: MGTTApiUrls.DELETE_ADMIN_CONFIG }}
                exportData={{ url: MGTTApiUrls.DOWNLOAD_ADMIN_CONFIG }}
                fetch={{ url: MGTTApiUrls.GET_ADMIN_CONFIG }}
                idAccessor="id"
                notification={notification}
                key={stateKey}
                onEditButtonClick={onEditButtonClick}
                onViewButtonClick={onViewButtonClick}
              />
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </Box>
  )
}

export default TablePage
